import { ModalHeaderBarStyleConfig } from '../../types';

export const styleConfig: ModalHeaderBarStyleConfig = {
  parts: ['title', 'subtitle', 'wrapper'],
  baseStyle: {
    wrapper: {},
    title: {},
    subtitle: {},
  },
  sizes: {
    default: {
      wrapper: {},
      title: {},
      subtitle: {},
    },
    small: {
      wrapper: {},
      title: {},
      subtitle: {},
    },
  },
  defaultProps: {
    size: 'default',
  },
};
